<template>
  <div class="dashboard">
    <div v-if="getRecentQuery.id">
      <div class="actions">
        <app-btn
          v-if="this.$route.params.fieldId == null"
          @click="deleteFarm"
          :danger="true"
          :loading="loading"
        >
          {{ $ml.get(`Delete farm`) }}
        </app-btn>
        <app-btn v-else @click="deleteField" :danger="true" :loading="loading">
          {{ $ml.get(`Delete field`) }}
        </app-btn>
      </div>
      <div class="table programs">
        <div class="buttons">
          <h2>{{ $ml.get(`Recent programs`) }}</h2>
          <div>
            <!-- <app-btn :disabled="!programs.is_available || value >= programs.max" @click="toggleCreateProgramPopup">{{$ml.get(`Add program`)}}</app-btn> -->
            <transition name="modal-fade-scale">
              <CreateProgramModal
                v-if="openPopup"
                @close="toggleCreateProgramPopup"
              />
            </transition>
          </div>
        </div>
        <div class="rows" v-if="info != null && info.length">
          <div class="row heading">
            <span class="name">{{ $ml.get(`program name`) }}</span>
            <span class="crop">{{ $ml.get(`crop`) }}</span>
            <!-- <span class="stage">{{$ml.get(`Status`)}}</span> -->
            <span class="date">{{ $ml.get(`Planting date`) }}</span>
          </div>
          <div class="row" v-for="program in info">
            <span class="name">
              <router-link :to="`/dashboard/programs/${program.id}`">
                {{ program.name }}
              </router-link>
            </span>
            <span class="crop">
              <template v-if="program.cropName">{{
                program.cropName
              }}</template>
              <template v-else>-</template>
            </span>
            <!-- <span class="stage">{{ program.currentStep }}</span> -->
            <span class="date">
              <template v-if="program.plantingDate.length < 15">{{
                program.plantingDate
              }}</template>
              <template v-else>-</template>
            </span>
          </div>
        </div>
        <div class="rows" v-else>
          <p>{{ $ml.get(`You don't have any programs yet`) }}</p>
        </div>
      </div>

      <!-- {{info}} -->
    </div>
    <div v-else>
      {{ $ml.get(`choose your farm before!`) }}
    </div>
  </div>
</template>

<script>
import API from "@/api";
import CreateProgramModal from "@/components/program/CreateProgramModal";

export default {
  props: {
    allFarms: {
      required: true,
    },
    allFields: {
      required: true,
    },
  },
  data() {
    return {
      info: null,
      // fields : null,
      getRecentQuery: {
        id: null,
        type: null,
        take: 5,
      },
      openPopup: false,
      loading: false,
    };
  },
  created() {
    this.sync();
  },
  watch: {
    values: function() {
      this.sync();
    },
  },
  computed: {
    values() {
      return (
        this.$route.params.fieldId,
        this.allFields,
        this.$route.params.farmId,
        this.allFarms
      );
    },
  },
  methods: {
    toggleCreateProgramPopup() {
      this.openPopup ^= true;
    },
    //=================================================================================
    deleteFarm() {
      this.loading = true;
      return API.fields
        .deleteFarm(this.$route.params.farmId)
        .then((res) => {
          this.$router.push("/dashboard/farms/list-view");
          this.$store.dispatch("farms/updateData");
          try {
            let result = JSON.parse(JSON.stringify(res));
            console.log(result.data.message);
            if (result.data.message == "Please buy a plan!") {
              this.$notify({
                group: "notices",
                title: this.$ml.get(`Please buy a plan before deleting farms.`),
                type: "error",
              });
            } else {
              this.$notify({
                group: "notices",
                title: this.$ml.get("Deleting completed"),
                text: this.$ml.get("Deleting farm has been successfully"),
                type: "success",
              });
            }
          } catch (e) {}
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //=================================================================================

    //=================================================================================
    deleteField() {
      this.loading = true;
      return API.fields
        .deleteField(this.$route.params.fieldId)
        .then((res) => {
          this.$router.push("/dashboard/farms/list-view");
          this.$store.dispatch("farms/updateData");
          try {
            let result = JSON.parse(JSON.stringify(res));
            console.log(result.data.message);
            if (result.data.message == "Please buy a plan!") {
              this.$notify({
                group: "notices",
                title: this.$ml.get(`Please buy a plan before deleting fields.`),
                type: "error",
              });
            } else {
              this.$notify({
                group: "notices",
                title: this.$ml.get("Deleting completed"),
                text: this.$ml.get("Deleting field has been successfully"),
                type: "success",
              });
            }
          } catch (e) {}
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //=================================================================================
    sync() {
      let fieldId = this.$route.params.fieldId;
      let farmId = this.$route.params.farmId;

      if (fieldId) {
        // this.fields = [];
        this.getRecentQuery.id = fieldId;
        this.getRecentQuery.type = "field";
      } else {
        // this.fields = this.allFarms.find(n => n.id == farmId).fields;
        this.getRecentQuery.id = farmId;
        this.getRecentQuery.type = "farm";
      }
      this.getInfo(
        farmId,
        fieldId,
        this.getRecentQuery.type,
        this.getRecentQuery.take
      );
    },
    getInfo(farmId, fieldId, type, take) {
      return API.fields
        .getInfoForDashboard(farmId, fieldId, type, take)
        .then((res) => {
          this.info = res.data.data;
        });
    },
  },
  components: {
    CreateProgramModal,
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  margin-left: 8px;
  background-color: #fff;
  // padding: 16px;
  border-radius: 5px;
  flex-grow: 2;

  @media (max-width: 768px) {
    margin-left: 0;

    & > div {
      padding: 0;
    }
  }

  & > div {
    padding: 16px;
  }
  .table {
    .rows {
      p {
        margin-top: 0;
      }
    }
    h2 {
      // margin: 0 0 24px 0;
    }
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 16px 8px;
      border-bottom: 1px solid #e4e5e6;
      &.heading {
        font-size: 12px;
        padding: 8px;
        text-transform: uppercase;
        span {
          color: #8b8d91;
          // font-weight: 400;
        }
      }
      span {
        padding-right: 16px;
        color: #4c5056;
        &:last-child {
          padding-right: 0;
        }
      }
    }

    &.programs {
      .row {
        span {
          // font-weight: 500;
          &.name {
            flex-basis: 35%;
          }
          &.crop {
            flex-basis: 25%;
          }
          &.stage {
            flex-basis: 25%;
          }
          &.date {
            flex-basis: 15%;
          }
        }
      }

      .buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
      }
    }
  }
  @media (max-width: 768px) {
    margin-top: 16px;
    margin-bottom: 16px;
    .table {
      &.programs {
        .buttons {
          flex-direction: column;
          align-items: flex-start;
        }
        .row {
          flex-direction: column;
          align-items: flex-start;
          span {
            padding-bottom: 8px;
          }
          &.heading {
            display: none;
          }
        }
      }
    }
  }
}
</style>
